<template>
  <b-row v-if="item.duration > 0">
    <b-col cols="12" lg="3">
      <label for="actionTakenAfterDeadlineExceeded" class="form-control-label">{{$t('views.excmtasktype.form.actionTakenAfterDeadlineExceeded')}}:</label>
      <b-form-group>
        <b-form-radio-group stacked id="actionTakenAfterDeadlineExceeded" v-model="item.actionTakenAfterDeadlineExceeded" name="actionTakenAfterDeadlineExceeded">
          <b-form-radio :value="0">{{$t('views.excmtasktype.form.actionTakenAfterDeadlineExceededOptions.doNothing')}}</b-form-radio>
          <b-form-radio :value="1">{{$t('views.excmtasktype.form.actionTakenAfterDeadlineExceededOptions.closeTaskWithoutCreatingNew')}}</b-form-radio>
          <b-form-radio :value="2">{{$t('views.excmtasktype.form.actionTakenAfterDeadlineExceededOptions.closeTaskWithDefaultNextTask')}}</b-form-radio>
          <b-form-radio :value="3">{{$t('views.excmtasktype.form.actionTakenAfterDeadlineExceededOptions.closeTaskWithCustomNextTask')}}</b-form-radio>
          <b-form-radio :value="4">{{$t('views.excmtasktype.form.actionTakenAfterDeadlineExceededOptions.doNotCloseTaskWithCustomNextTask')}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-col>
    <b-col cols="12" lg="3" v-if="item.actionTakenAfterDeadlineExceeded === 3 || item.actionTakenAfterDeadlineExceeded === 4">
      <label for="tasksToCreateAfterDeadlineExceeded" class="form-control-label">{{$t('views.excmtasktype.form.tasksToCreateAfterDeadlineExceeded')}}:</label>
      <multi-select :options="taskTypeAllowedOptions" :selected-options="tasksToCreateAfterDeadlineExceeded" @select="selectTasksToCreateAfterDeadlineExceeded"></multi-select>
    </b-col>
    <b-col cols="12" lg="3" v-if="item.actionTakenAfterDeadlineExceeded === 2 ||item.actionTakenAfterDeadlineExceeded === 3 || item.actionTakenAfterDeadlineExceeded === 4">
      <label for="poolTaskRecipient" class="form-control-label">{{$t('views.excmtasktype.form.poolTaskRecipient')}}:</label>
      <b-form-radio-group stacked id="poolTaskRecipient" v-model="item.poolTaskRecipient" name="poolTaskRecipient">
        <b-form-radio :value="0">{{$t('views.excmtasktype.form.poolTaskRecipientOptions.returned')}}</b-form-radio>
        <b-form-radio :value="1">{{$t('views.excmtasktype.form.poolTaskRecipientOptions.regionCoordinator')}}</b-form-radio>
        <b-form-radio :value="2">{{$t('views.excmtasktype.form.poolTaskRecipientOptions.currentUserData')}}</b-form-radio>
      </b-form-radio-group>
    </b-col>
    <b-col cols="12" lg="3">
      <div :class="['form-group', isInvalid('daysToCreateTaskAfterDeadlineExceeded') ? 'has-danger' : '']">
        <label
          for="excmtasktype_daysToCreateTaskAfterDeadlineExceeded"
          class="form-control-label">{{$t('views.excmtasktype.form.daysToCreateTaskAfterDeadlineExceeded')}}:</label>
        <input
          id="excmtasktype_daysToCreateTaskAfterDeadlineExceeded"
          v-model="item.daysToCreateTaskAfterDeadlineExceeded"
          :class="['form-control', isInvalid('daysToCreateTaskAfterDeadlineExceeded') ? 'is-invalid' : '']"
          type="number"
          placeholder=""
          @input="handleUpdateField('daysToCreateTaskAfterDeadlineExceeded', $event.target.value)">
        <div
          v-if="isInvalid('daysToCreateTaskAfterDeadlineExceeded')"
          class="invalid-feedback">{{ violations.daysToCreateTaskAfterDeadlineExceeded }}</div>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import getId from '@/utils/getIdFromLink'
import { MultiSelect } from 'vue-search-select'
import { mapGetters } from 'vuex'

export default {
  name: 'taskDeadlineExceededOptions',
  components: {
    MultiSelect
  },
  props: {
    item: {},
    handleUpdateField: {},
    isInvalid: {},
    violations: {}
  },
  data () {
    return {
      tasksToCreateAfterDeadlineExceeded: []
    }
  },
  created () {
    this.initialTasksToCreateAfterDeadlineExceededHandler()
  },
  computed: {
    ...mapGetters({
      taskTypeOptions: 'excmtasktype/list/getTaskTypeOptions'
    }),
    taskTypeAllowedOptions () {
      return this.taskTypeOptions.map(option => {
        return { value: getId(option.value), text: option.text + (option.idCasesType ? ' (' + option.idCasesType.title + ')' : '') }
      })
    }
  },
  methods: {
    initialTasksToCreateAfterDeadlineExceededHandler () {
      if (this.item.tasksToCreateAfterDeadlineExceeded) {
        this.tasksToCreateAfterDeadlineExceeded = this.item.tasksToCreateAfterDeadlineExceeded.map(value => {
          return this.taskTypeAllowedOptions.find(option => getId(option.value) === value)
        })
      }
    },
    selectTasksToCreateAfterDeadlineExceeded (selected) {
      this.tasksToCreateAfterDeadlineExceeded = selected
      this.item.tasksToCreateAfterDeadlineExceeded = selected.map(option => getId(option.value))
    }
  }
}
</script>
